// ID generation service

// Conversation/thread ids. Uses a real UUID (not a short id) because thread
// ids are generated client-side and share a single per-tenant namespace.
// With embedded chat (show_history), many distinct end-users mint ids inside
// one tenant, and the backend appends to an existing thread_id on collision,
// so a short id risked silently merging two users' conversations. It's also
// the same format the public streaming API requires from external callers
// (see docs/ellie_streaming_public_api.md) — one thread_id format across
// every surface. (Name kept for compatibility with existing call sites;
// previously nanoid — existing nanoid-format thread_ids already stored
// keep working, this only changes what newly-minted ones look like.)
export function shortid() {
  return crypto.randomUUID();
}

